export const ZEUS_UI_ID = /^[a-z][a-z0-9.-]{0,79}$/
export const ZEUS_UI_OPS = ['highlight', 'click', 'fill', 'select', 'pick']
export const ZEUS_UI_KINDS = ['button', 'tab', 'step', 'field', 'image', 'table', 'text', 'card']
export const clip = (value, max = 60) => String(value ?? '').replace(/\s+/g, ' ').trim().slice(0, max)
export const toKey = value => String(value ?? '').toLowerCase().replace(/[^a-z0-9.-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40)
export const text = el => clip(el?.textContent)
export const suffix = prefix => el => el.dataset.test.slice(prefix.length)
